import { VIEWPORT_HEIGHT, VIEWPORT_WIDTH } from '../../../../domain/Constants';

/** Convert a client-space delta into design (1080×1920) units under App scale. */
export function clientDeltaToDesign(
  element: Element,
  clientDx: number,
  clientDy: number,
): { dx: number; dy: number } {
  const width = element.getBoundingClientRect().width;
  const scale = width > 0 ? width / VIEWPORT_WIDTH : 1;
  return {
    dx: clientDx / scale,
    dy: clientDy / scale,
  };
}

/** Client point → CSS pixels relative to the element's border box. */
export function clientPointToElement(
  element: Element,
  clientX: number,
  clientY: number,
): { x: number; y: number } {
  const rect = element.getBoundingClientRect();
  return {
    x: clientX - rect.left,
    y: clientY - rect.top,
  };
}

/** Client point → design coords relative to the element's top-left. */
export function clientPointToDesign(
  element: Element,
  clientX: number,
  clientY: number,
): { x: number; y: number } {
  const rect = element.getBoundingClientRect();
  const scaleX = rect.width > 0 ? rect.width / VIEWPORT_WIDTH : 1;
  const scaleY = rect.height > 0 ? rect.height / VIEWPORT_HEIGHT : 1;
  return {
    x: (clientX - rect.left) / scaleX,
    y: (clientY - rect.top) / scaleY,
  };
}
